var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:time-fill",
    clipPath: "url(#clip0_1136_112648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 1.66663C14.6023 1.66663 18.3332 5.39746 18.3332 9.99996C18.3332 14.6025 14.6023 18.3333 9.99984 18.3333C5.39734 18.3333 1.6665 14.6025 1.6665 9.99996C1.6665 5.39746 5.39734 1.66663 9.99984 1.66663ZM9.99984 4.99996C9.77882 4.99996 9.56686 5.08776 9.41058 5.24404C9.2543 5.40032 9.1665 5.61228 9.1665 5.83329V9.99996C9.16655 10.221 9.25438 10.4329 9.41067 10.5891L11.9107 13.0891C12.0678 13.2409 12.2783 13.3249 12.4968 13.323C12.7153 13.3211 12.9243 13.2335 13.0789 13.079C13.2334 12.9245 13.321 12.7155 13.3229 12.497C13.3248 12.2785 13.2408 12.068 13.089 11.9108L10.8332 9.65496V5.83329C10.8332 5.61228 10.7454 5.40032 10.5891 5.24404C10.4328 5.08776 10.2209 4.99996 9.99984 4.99996Z",
    fill: "white",
    fillOpacity: 0.87
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_112648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.daf172332b9f760e7dbebb2369b92a89.svg";
export { ForwardRef as ReactComponent };